import type * as lazyIndex from './lazyIndex';
import { LazyModule, LazyImport, type LazyComponent } from 'owa-bundling';
import { createLazyApolloComponent } from 'owa-apollo-component';
import type { MoveToFolderProps as MoveToFolderV9Props } from './components/MoveToFolderV9';
import type { MoveToFolderProps } from './components/MoveToFolder';
export { getMoveToMenuProps } from './components/getMoveToMenuProps';
export type { default as MoveToFolderType } from './store/schema/MoveToFolderType';
export type { default as MoveToMenuItem } from './store/schema/MoveToMenuItem';
export { MAIN_WINDOW_ID } from './utils/constants';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(
    () => import(/* webpackChunkName: "MoveTo"*/ './lazyIndex'),
    {
        name: 'MoveTo',
    }
);

export const lazyGetFoldersForMoveTo: LazyImport<
    typeof lazyIndex.getFoldersForMoveTo,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.getFoldersForMoveTo);

// Delayed Loaded Components
// Need to be wrapped with lazy apollo component so that the component is wrapped with the apollo provider
// and apollo client instance is available in the apollo hooks
export const MoveToFolder: LazyComponent<MoveToFolderProps, unknown, void> =
    /* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
     * DO NOT COPY-PASTE!, this function can't be called in the module scope, please move it inside a function
     *	> Function createLazyApolloComponent called at module scope is not allowed. This may cause unwanted side effects. */
    createLazyApolloComponent(lazyModule, m => m.MoveToFolder);

export const MoveToFolderV9: LazyComponent<MoveToFolderV9Props, unknown, void> =
    /* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
     * DO NOT COPY-PASTE!, this function can't be called in the module scope, please move it inside a function
     *	> Function createLazyApolloComponent called at module scope is not allowed. This may cause unwanted side effects. */
    createLazyApolloComponent(lazyModule, m => m.MoveToFolderV9);
